module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Minimize_16"],"path":[{"$":{"d":"M15,6H10V1l1.79,1.79,2.5-2.5,1.41,1.41-2.5,2.5Zm0,4H10v5l1.79-1.79,2.5,2.5,1.41-1.41-2.5-2.5ZM2.79,11.79l-2.5,2.5,1.41,1.41,2.5-2.5L6,15V10H1ZM1.71.29.29,1.71l2.5,2.5L1,6H6V1L4.21,2.79Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Minimize_16.svg
// module id = R/3F
// module chunks = 1